// extracted by css-extract-rspack-plugin
export default {"cls1":"YourPaperCard-cls1_zgU","cls2":"YourPaperCard-cls2_Nsv YourPaperCard-cls1_zgU"};